import React, { useMemo, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { ghostBtn } from '../ui';

const idOf = (x) => (typeof x === 'object' && x ? x.id : x);

export function useSecondaryFilter(nodes, links, root) {
  const [hide, setHide] = useState(false);
  const out = useMemo(() => {
    const drop = new Set(nodes.filter((n) => n.secondary && !n.ubo && !n.checked && n.id !== root).map((n) => n.id));
    if (!hide || !drop.size) return { nodes, links, count: drop.size };
    return { nodes: nodes.filter((n) => !drop.has(n.id)), links: links.filter((l) => !drop.has(idOf(l.source)) && !drop.has(idOf(l.target))), count: drop.size };
  }, [nodes, links, root, hide]);
  return { ...out, hide, setHide };
}

export function SecondaryToggle({ filter }) {
  if (!filter.count) return null;
  const Icon = filter.hide ? Eye : EyeOff;
  return (
    <button type="button" onClick={() => filter.setHide(!filter.hide)} className={`${ghostBtn} h-10 px-4 flex items-center gap-2 text-sm`} data-testid="graph-toggle-secondary"
      title="Soggetti di contorno: società sorelle e partecipate di altre società del gruppo">
      <Icon size={15} />{filter.hide ? `Mostra contorno (${filter.count})` : `Nascondi contorno (${filter.count})`}
    </button>
  );
}
